/*
 * @Description:
 * @Version: 1.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
import { reactive, toRefs } from 'vue';
export default function setScrollBar() {
  const data = reactive({
    scrollShow: false
  });
  // 容器滚动时
  const handleScroll = () => {
    data.scrollShow = true;
  };
  // 鼠标离开时
  const mouseLeave = () => {
    data.scrollShow = false;
  };
  return {
    handleScroll,
    mouseLeave,
    ...toRefs(data)
  };
}
